import {
  type FormFieldDescriptor,
  type NarrowFieldsByValueType,
  type TidalFormBridgeOptions,
  type TidalFormState,
  useTidalFormBridge,
} from '@workwave-tidal/core/form'

import { RecurrenceSettings } from './RecurrenceSettings'

import { UiFramework } from './types'

export type RecurrenceSettingsFieldProps = {
  uiFramework?: UiFramework
  inEditMode: boolean
}

export type InputValue = uui.domain.ui.forms.RecurrenceSettings

export type InputProps<
  TargetField extends NarrowFieldsByValueType<AcceptedFormValue, State, FormFieldDescriptor<State>>,
  State extends TidalFormState,
  AcceptedFormValue = InputValue,
> = {
  recurrenceSettingsFieldProps: RecurrenceSettingsFieldProps
} & TidalFormBridgeOptions<InputValue, TargetField, State, AcceptedFormValue>

export function RecurrenceSettingsField<
  TargetField extends NarrowFieldsByValueType<AcceptedFormValue, State, FormFieldDescriptor<State>>,
  State extends TidalFormState,
  AcceptedFormValue = InputValue,
>(props: InputProps<TargetField, State, AcceptedFormValue>) {
  const {
    recurrenceSettingsFieldProps: { uiFramework, inEditMode },
    initialValue,
    validateOn = 'change',
    ...bridgeOptions
  } = props

  const {
    fieldInfo: { value, onChange },
  } = useTidalFormBridge<InputValue, TargetField, State, AcceptedFormValue>({
    ...bridgeOptions,
    validateOn,
    initialValue,
  })

  return (
    <RecurrenceSettings
      value={value}
      onChange={onChange}
      uiFramework={uiFramework}
      inEditMode={inEditMode}
    />
  )
}
